// The built-in policies' IDs, apart from the project model (Project.ts): code on every page imports
// them without bundling it.
export const DEFAULT_MODERATION_PROFILE_ID = "general-community";
/** The built-in policies (`BUILT_IN_MODERATION_PROFILES`), in the order the portal offers them. */
export const POLICY_PRESET_IDS = [
  DEFAULT_MODERATION_PROFILE_ID,
  "children-platform",
  "education-support",
  "wholesome-community",
] as const;
export type PolicyPresetId = (typeof POLICY_PRESET_IDS)[number];
